var render = function () {
  var _vm$value, _vm$value$resume, _vm$value$resume$prof, _vm$value2, _vm$value2$resume, _vm$value2$resume$pro, _vm$value3, _vm$value3$resume, _vm$value3$resume$per, _vm$value4, _vm$value4$resume, _vm$value4$resume$per, _vm$value5, _vm$value5$resume, _vm$value5$resume$per;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    class: {
      'employment-item--list': _vm.list
    },
    staticStyle: {
      "overflow": "unset"
    },
    attrs: {
      "rounded": "lg",
      "outlined": ""
    }
  }, [_c('div', {
    staticClass: "pa-20 pa-md-24"
  }, [_c('v-row', {
    staticClass: "row--x-large",
    attrs: {
      "align": "center"
    }
  }, [!_vm.list ? _c('v-col', {
    staticClass: "mb-10 mb-lg-0",
    attrs: {
      "cols": "12",
      "lg": "auto"
    }
  }, [_c('v-checkbox', {
    attrs: {
      "value": true,
      "hide-details": ""
    },
    on: {
      "change": function change($event) {
        return _vm.$emit('checkApplicant', _vm.value);
      }
    },
    model: {
      value: _vm.checkedApplicant,
      callback: function callback($$v) {
        _vm.checkedApplicant = $$v;
      },
      expression: "checkedApplicant"
    }
  })], 1) : _vm._e(), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "auto"
    }
  }, [_c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-avatar', {
    attrs: {
      "color": "grey"
    }
  }, [_c('v-img', {
    attrs: {
      "src": (_vm$value = _vm.value) === null || _vm$value === void 0 ? void 0 : (_vm$value$resume = _vm$value.resume) === null || _vm$value$resume === void 0 ? void 0 : (_vm$value$resume$prof = _vm$value$resume.profile) === null || _vm$value$resume$prof === void 0 ? void 0 : _vm$value$resume$prof.url
    }
  }, [_c('v-fade-transition', [_c('v-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !((_vm$value2 = _vm.value) !== null && _vm$value2 !== void 0 && (_vm$value2$resume = _vm$value2.resume) !== null && _vm$value2$resume !== void 0 && (_vm$value2$resume$pro = _vm$value2$resume.profile) !== null && _vm$value2$resume$pro !== void 0 && _vm$value2$resume$pro.url),
      expression: "!value?.resume?.profile?.url"
    }],
    attrs: {
      "color": "white"
    }
  }, [_vm._v("mdi-account")])], 1)], 1)], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-row', {
    attrs: {
      "no-gutters": "",
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('h5', {
    staticClass: "page-text--lg font-weight-medium pr-4 pr-lg-0 min-w-lg-80px"
  }, [_vm._v(" " + _vm._s((_vm$value3 = _vm.value) === null || _vm$value3 === void 0 ? void 0 : (_vm$value3$resume = _vm$value3.resume) === null || _vm$value3$resume === void 0 ? void 0 : (_vm$value3$resume$per = _vm$value3$resume.personalInformation) === null || _vm$value3$resume$per === void 0 ? void 0 : _vm$value3$resume$per.name) + " ")])]), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('p', {
    staticClass: "page-text grey-9--text"
  }, [_vm._v(" (" + _vm._s((_vm$value4 = _vm.value) === null || _vm$value4 === void 0 ? void 0 : (_vm$value4$resume = _vm$value4.resume) === null || _vm$value4$resume === void 0 ? void 0 : (_vm$value4$resume$per = _vm$value4$resume.personalInformation) === null || _vm$value4$resume$per === void 0 ? void 0 : _vm$value4$resume$per.genderText) + ", " + _vm._s((_vm$value5 = _vm.value) === null || _vm$value5 === void 0 ? void 0 : (_vm$value5$resume = _vm$value5.resume) === null || _vm$value5$resume === void 0 ? void 0 : (_vm$value5$resume$per = _vm$value5$resume.personalInformation) === null || _vm$value5$resume$per === void 0 ? void 0 : _vm$value5$resume$per.age) + ") ")])])], 1)], 1)], 1)], 1), _c('v-col', {
    staticClass: "employment-item__center",
    attrs: {
      "cols": "12",
      "lg": ""
    }
  }, [_c('ul', {
    staticClass: "dot-texts"
  }, _vm._l(_vm.cardTextList(), function (text) {
    return _c('li', {
      key: text,
      staticClass: "dot-text page-text grey-6--text ellip"
    }, [_vm._v(" · " + _vm._s(text) + " ")]);
  }), 0)]), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "auto"
    }
  }, [_c('v-row', {
    staticClass: "row--small"
  }, [_c('v-col', {
    attrs: {
      "lg": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "outlined": "",
      "block": "",
      "color": "primary"
    },
    on: {
      "click": function click($event) {
        _vm.$refs['application-view'].shows = true;
      }
    }
  }, [_vm._v("지원자 정보")])], 1), _vm.list ? _c('v-col', {
    attrs: {
      "lg": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "outlined": "",
      "block": "",
      "color": "grey-d"
    },
    on: {
      "click": function click($event) {
        return _vm.cancelApplicant(_vm.value);
      }
    }
  }, [_c('span', {
    staticClass: "grey-6--text"
  }, [_vm._v("취소")])])], 1) : _vm._e()], 1)], 1)], 1)], 1), _c('application-view', _vm._b({
    ref: "application-view",
    on: {
      "input": function input(item) {
        return _vm.$emit('input', item);
      }
    }
  }, 'application-view', {
    value: _vm.value,
    recruitment: _vm.recruitment
  }, false))], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }